import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoIosArrowDown } from "react-icons/io";

const flags = [ 
  { src: "/assets/flags/am.png", alt: "Armenia Flag", name: "am", label: "Հայ" },
  { src: "/assets/flags/en.png", alt: "USA Flag", name: "en", label: "Eng" },
  { src: "/assets/flags/ru.png", alt: "Russian Flag", name: "ru", label: "Рус" },
];

const LanguageSelect = ({ onChange }) => {
  const { i18n } = useTranslation();
  const [isOpenLang, setIsOpenLang] = useState(false);
  const [selectedFlag, setSelectedFlag] = useState(flags[0]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const currentLang = i18n.language || "am";
    const currentFlag =
      flags.find((flag) => flag.name === currentLang) || flags[0];

    setSelectedFlag(currentFlag);
  }, [i18n.language]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpenLang(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleFlagSelect = (flag) => {
    setSelectedFlag(flag);
    setIsOpenLang(false);

    if (onChange) {
      onChange(flag.name);
    }
  };

  const availableFlags = flags.filter(
    (flag) => flag.name !== selectedFlag.name
  );

  return (
    <div
      className="relative inline-block text-left"
      ref={dropdownRef}
    >
      {/* Selected */}
      <div
        onClick={() => setIsOpenLang(!isOpenLang)}
        className="flex items-center gap-2 justify-between cursor-pointer hover:border-primary transition"
      >
        <img
          src={selectedFlag.src}
          alt={selectedFlag.alt}
          className="w-8 h-6 rounded-[3px] object-cover"
        />
        <span className="font-medium text-[15px]">
          {selectedFlag.label}
        </span>
        <IoIosArrowDown className="ml-1" />
      </div>

      {/* Dropdown */}
      {isOpenLang && (
        <div className="absolute mt-2 w-full bg-white dark:bg-secondary_black shadow-md rounded-[5px] border-2 border-gray-200 dark:border-[#3a3a3a] z-50 overflow-hidden">
          {availableFlags.map((flag) => (
            <div
              key={flag.name}
              onClick={() => handleFlagSelect(flag)}
              className="flex items-center gap-2 px-4 py-2 hover:bg-primary hover:text-white cursor-pointer transition"
            >
              <img
                src={flag.src}
                alt={flag.alt}
                className="w-8 h-6 rounded-[3px] object-cover"
              />
              <span className="font-medium text-[15px]">
                {flag.label}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelect;